import { Dispatch, SetStateAction } from 'react';

import { RoomDetailsData } from 'src/features/room/room.types';

export enum EnvironmentStatusOptions {
  STARTING = 'starting',
  ACTIVE_BUT_EMPTY = 'activeButEmpty',
  GENERATING_FIRST_ENVIRONMENT = 'generatingFirstEnvironment',
  ACTIVE = 'active',
  ANOTHER_ENVIRONMENT_ACTIVE = 'anotherEnvironmentActive',
  GENERATING = 'generating',
  NEW_ENVIRONMENT = 'newEnvironment',
  RESETTING = 'resetting',
}

export enum TabOptions {
  ENVIRONMENT = 'Environment',
  CREDENTIALS = 'Credentials',
}

export type AWSCloudDetailsStatusMapping = {
  tagType: string;
  circleIconColor: string;
  iconTagText: string;
  panelText?: string;
  showRoomList: boolean;
  showClose: boolean;
  showGenerateEnvironment: boolean;
  showResetEnvironment: boolean;
};

export interface AWSCredentials {
  urlLink: string;
  username: string;
  accessKeyId: string;
  secretAccessKey: string;
  defaultConsolePassword: string;
}

export interface AWSCloudDetailsModalProps {
  open: boolean;
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  environmentStatus: EnvironmentStatusOptions;
  roomsList?: string[];
  awsCredentials?: AWSCredentials;
  roomDetails?: RoomDetailsData;
}

export type TagType = 'success' | 'error' | 'info' | 'warning' | 'neutral';
